import createCrudService from '@core/api/create-crud-service';
import { queryClient } from '@src/core/api/query-client';
import { request } from '@src/core/api/request';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';

import type { TBaseQuery } from '@src/shared/types/base-query';
import type { TField } from '@src/shared/types/field';
import { useMutation } from '@tanstack/react-query';

export type TProgramFieldQuery = {
  is_required?: boolean;
  section?: number | string;
  title?: string;
  type?: TField['type'];
} & TBaseQuery;

type TProgramFieldPayload = {
  title: string;
  type: string;
  section: number | string;
  description?: string;
  options?: string[];
  is_required?: boolean;
  note?: string;
  attachment_type?: string | null;
  attachment?: string | number | null;
};

const programFieldApi = (programId?: string | number) => {
  return {
    ...createCrudService<TField, TProgramFieldQuery, TProgramFieldPayload>({
      queryKey: [QUERY_KEYS.getProgramFields],
      url: `programs/${programId}/fields`,
      factory: {
        fetch: {
          tanstackOptions: { enabled: !!programId },
          requestOptions: (params) => ({
            params: {
              ...params,
              o: ['order'],
              page_size: 200,
            },
          }),
        },
        update: {
          tanstackOptions: { mutationKey: ['update-question'] },
        },
      },
    }),

    useDuplicate: () => {
      return useMutation({
        mutationFn: async ({ id }: { id: string | number }) => {
          return await request<TField>({
            url: `programs/${programId}/fields/${id}/duplicate/`,
            method: 'POST',
          });
        },
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: [QUERY_KEYS.getProgramFields],
          });
        },
      });
    },
  };
};

export default programFieldApi;
